import { render, staticRenderFns } from "./LuckLogo.vue?vue&type=template&id=2bed2970&scoped=true"
import script from "./LuckLogo.vue?vue&type=script&lang=js"
export * from "./LuckLogo.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=2bed2970&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bed2970",
  null
  
)

export default component.exports